<div class="app-dashboard-studio-cell white" [ngStyle]="{ 'height': fullWidth ? '100%' : cell.height + 'px', 'width': fullWidth ? '100%' : cell.width + 'px' }">
  <div class="app-dashboard-studio-cell-content" *ngIf="widgetNotFound == false ; else notFound">
    <app-widget-studio-chart *ngIf="widgetLayers" [widgetLayers]="widgetLayers" [width]="cell.width" [height]="cell.height" [resizeRatio]="cell.resizeRatio" [dashboardUID]="dashboardLayout.uid.value"></app-widget-studio-chart>
  </div>
</div>

<ng-template #notFound>
  <app-empty [action]="false" [description]="'WIDGET_NOT_FOUND/TEXT'"></app-empty>
</ng-template>